module.exports = __webpack_public_path__ + "static/img/qzsp-details.0847a2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/qzsp-details.png
// module id = L3Ln
// module chunks = 0